import React from 'react'
import CommunityArea from '../components/CommunityArea'
import Footer from '../components/Footer'

const Communities = () => {
    return (
        <>
            <CommunityArea />
            <br></br>
            <br></br>
            <br></br>
            <Footer />
        </>
    )
}

export default Communities;